"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var textIndent_1 = __importDefault(require("../../../util/textIndent"));
var TextField = function (_a) {
    var textData = _a.textData;
    return (react_2.default.createElement(react_1.Box, { width: "100%", css: [
            textData.style,
            "ul {\n                    padding-left: 1.5em;\n                    list-style-type: disc;\n                    list-style-position: outside;\n                }",
        ], className: "" + (textData.class ? textData.class : "") }, textData.data.body && (0, textIndent_1.default)(textData.data.body)));
};
exports.TextField = TextField;
